import clsx from 'clsx';
import React from 'react';

import DeepResearchSection from '@components/pages/DeepResearchSection';
import useModifiedBenefits from '@hooks/useModifiedBenefits';
import { OfferOption, Reporter, SelectedOffer } from '@utils/backend-api/subscribe';

import Awards from './Awards';
import CompaniesAndLeaders from './CompaniesAndLeaders';
import Experts from './Experts';
import Header from './Header';
import OfferCards from './OfferCards';
import OfferTable from './OfferTable';
import TechAndFinance from './TechAndFinance';
import TheInformationDifference from './TheInformationDifference';
import TheInformationPro from './TheInformationPro';
import { MONTHLY } from './constants';

export interface OfferSelectionProps {
  offers: OfferOption[];
  offerTitleClass?: string;
  onOfferClick: () => void;
  reporters?: Reporter[];
  setSelectedOffer?: (plan: SelectedOffer) => void;
  isGiftLanding?: boolean;
  ypOffer?: OfferOption;
}

const OfferSelection = ({
  offers,
  onOfferClick,
  reporters,
  setSelectedOffer,
  isGiftLanding,
  ypOffer,
}: OfferSelectionProps) => {
  const modifiedBenefits = useModifiedBenefits(
    offers.find(({ billingFrequency }) => billingFrequency === MONTHLY),
    offers.find(({ billingFrequency, isPro }) => !isPro && billingFrequency !== MONTHLY),
    offers.find(({ isPro }) => !!isPro)
  );

  return (
    <>
      <div
        className={clsx('px-16 pt-32 sm:px-28', {
          'sm:pt-48': isGiftLanding,
          'sm:pt-64': !isGiftLanding,
        })}
      >
        <div className="m-auto max-w-full md:max-w-[1174px]">
          <Header isGiftLanding={isGiftLanding} />
          <OfferTable
            benefits={modifiedBenefits}
            offers={offers}
            onOfferClick={onOfferClick}
            setSelectedOffer={setSelectedOffer}
            isGiftLanding={isGiftLanding}
          />
          {ypOffer && (
            <>
              <OfferCards
                onOfferClick={onOfferClick}
                setSelectedOffer={setSelectedOffer}
                ypOffer={ypOffer}
              />
            </>
          )}

          {!isGiftLanding && (
            <>
              <TheInformationDifference />
              <CompaniesAndLeaders />
              <TechAndFinance />
              <DeepResearchSection isProSubscriberNotBot={false} />
            </>
          )}
        </div>
      </div>
      {!isGiftLanding && (
        <>
          <TheInformationPro />
          {reporters.length > 0 && <Experts reporters={reporters} />}
          <Awards />
        </>
      )}
    </>
  );
};

export default OfferSelection;
